export const LOCALSTORAGEAUTHUSERINFO = "currency-gram-auth-user-info";
export const LOCALSTORAGEREFERENCEDATA = "currency-gram-reference-data";
export const LOCALSTORAGEUSERLOGGEDINTIME = "currency-gram-user-logged-in-time";
export const LOCALSTORAGEREMEMBERMEUSER = "currency-gram-remember-me-user";
export const LOCALSTORAGECOMMUNITYAUTHUSERINFO = "currency-gram-community-auth-user-info";

export const SESSIONSTORAGESENDMONEYFORMINPUT = "send-money-form-values";
